import s from './Node.module.css';
import type { ITask, TTaskCategory } from '../data/types';

interface INodeProps {
  task: ITask;
  isDimmed: boolean;
  onSelect: (task: ITask) => void;
}

const CATEGORY_LABEL: Record<TTaskCategory, string> = {
  backend: 'Сервер',
  'frontend-partner': 'Кабинет врача',
  'frontend-client': 'Кабинет пациента',
  'frontend-admin': 'Управление',
  database: 'Данные',
  infra: 'Платформа',
  integration: 'Внешние сервисы',
};

const statusToClass = (status: ITask['status']) =>
  status === 'done' ? 'statusDone' : status === 'in_progress' ? 'statusInProgress' : 'statusTodo';

const dotClass = (status: ITask['status']) =>
  status === 'done' ? 'done' : status === 'in_progress' ? 'inProgress' : 'todo';

export const Node = ({ task, isDimmed, onSelect }: INodeProps) => {
  const animationDelay = `${Math.min((task.position.x + task.position.y) * 0.04, 320)}ms`;

  return (
    <button
      type="button"
      data-roadmap-node
      className={`${s.node} ${s[statusToClass(task.status)]} ${isDimmed ? s.dimmed : ''}`}
      style={{ left: task.position.x, top: task.position.y, animationDelay }}
      onClick={() => onSelect(task)}
    >
      <div className={s.head}>
        <span className={`${s.statusDot} ${s[dotClass(task.status)]}`} aria-hidden="true" />
        <span className={s.title}>{task.title}</span>
      </div>
      <p className={s.description}>{task.description}</p>
      <div className={s.metaRow}>
        <span className={s.categoryTag}>{CATEGORY_LABEL[task.category]}</span>
      </div>
    </button>
  );
};
